import React, { useState } from 'react';
import { styles } from './useHeaderNavationDrawerStyles';
import { withStyles } from '@material-ui/core';
import DrawerImg from 'modules/layout/components/Header/assets/darwer.svg';
import CloseImg from 'modules/layout/components/Header/assets/close.svg';
import { SwipeableDrawer } from '@material-ui/core';
import { Box } from '@material-ui/core';
// import { DraweCloseComp } from '../DrawerClose';
import { Button } from 'modules/uiKit/Button';
import { NavLink } from 'react-router-dom';
import { Social } from 'modules/layout/components/Social';
import { DynamicBitcoinRoutesConfig } from 'modules/dynamicBitcoin/Routes';
import { DocsRoutesConfig } from 'modules/docs/Routes';

type Anchor = 'top';
const lindSpaceStyles = {};
const HeaderDrawerNavComponents = ({ classes = {} }: { classes: any }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }
      setIsOpen(open);
    };
  return (
    <>
      <Box
        className={classes.root}
        onClick={toggleDrawer('top', !isOpen)}
        onKeyDown={toggleDrawer('top', !isOpen)}
      >
        <img
          src={isOpen ? CloseImg : DrawerImg}
          alt=""
          className={classes.userIcon}
        />
      </Box>
      <SwipeableDrawer
        anchor={'top'}
        open={isOpen}
        onClose={toggleDrawer('top', false)}
        onOpen={toggleDrawer('top', true)}
        classes={{
          paper: classes.paper,
        }}
      >
        <Box className={classes.drawerBody}>
          {/* <DraweCloseComp toggleDrawer={toggleDrawer('right', false)} /> */}
          <Box className={classes.drawerContent}>
            <Box className={classes.linkWrap}>
              <Button
                component={NavLink}
                variant="text"
                style={lindSpaceStyles}
                activeClassName={classes.activeLink}
                className={classes.link}
                onClick={toggleDrawer('top', false)}
                to={DynamicBitcoinRoutesConfig.Index.path}
              >
                GENE
              </Button>
              <Button
                component={NavLink}
                variant="text"
                style={lindSpaceStyles}
                activeClassName={classes.activeLink}
                className={classes.link}
                onClick={toggleDrawer('top', false)}
                to={DocsRoutesConfig.Index.path}
              >
                DOCS
              </Button>
              <Box className={classes.socialBox}>
                <Social />
              </Box>
            </Box>
          </Box>
        </Box>
      </SwipeableDrawer>
    </>
  );
};

const HeaderNavationDrawer = withStyles(styles)(HeaderDrawerNavComponents);
export { HeaderNavationDrawer };
